import React, { memo } from 'react';
import { useFeatures } from 'reaxl-features';

import {
    Footer as KBBFooter,
} from '@kbbsdk/global-sdk/navigation/web';

const KBBFooterContainer = memo(({ navS3Data = {}, forceOneTrust }) => {
    const { col_enable_one_trust_footer: [colEnableOneTrustFooter] } = useFeatures(['col_enable_one_trust_footer']);

    return (
        <KBBFooter
            enableGtm
            navigation={navS3Data}
            enableOneTrust={forceOneTrust !== undefined ? forceOneTrust : colEnableOneTrustFooter}
        />
    );
});

export default KBBFooterContainer;
